/**
 * Get Started Page - Multi-step intake wizard for discovery calls
 *
 * Uses a Typeform-style wizard to collect lead information
 * before redirecting to Calendly for booking.
 */

import { IntakeWizard } from '@/components/intake'
import { useSEO } from '@/hooks/useSEO'
import { generateBreadcrumbs, breadcrumbLabels } from '@/components/Breadcrumbs'

export default function GetStartedPage() {
  const breadcrumbs = generateBreadcrumbs('/get-started', breadcrumbLabels)

  useSEO({
    title: 'Get Started',
    description:
      "Schedule a free 30-minute discovery call to discuss how Fugue Lab can help your music organization thrive online. Fill out our intake form and we'll connect.",
    url: '/get-started',
    canonical: '/get-started',
    breadcrumbs,
    schema: {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: 'Get Started with Fugue Lab',
      description: "Schedule a free consultation to discuss your music organization's digital needs.",
      mainEntity: {
        '@type': 'Organization',
        name: 'Fugue Lab',
        email: 'hello@fuguelab.com',
        url: 'https://fuguelab.com',
      },
    },
  })

  return <IntakeWizard />
}
